import { create } from 'zustand';

// Playback belongs to the app session, never to a chat route or modal lifetime.
// Do not persist answer text/audio URLs to disk or resume after sign-out.
export const useReadAloudStore = create((set, get) => ({
  session: null,
  expanded: false,
  playback: {},
  controls: null,
  composerSlots: 0,
  start: (text) => {
    const trimmed = typeof text === 'string' ? text.trim() : '';
    if (!trimmed) return;
    if (get().session?.text === trimmed) {
      set({ expanded: false });
      return;
    }
    set({ session: { text: trimmed, id: (get().session?.id || 0) + 1 }, expanded: false, playback: {}, controls: null });
  },
  setPlayback: (playback) => set({ playback }),
  minimize: () => set({ expanded: false }),
  expand: () => set({ expanded: true }),
  stop: () => set({ session: null, expanded: false, playback: {}, controls: null }),
}));
